import { Component } from '@angular/core';
import { LoaderHandlerService } from '../../common-services/overlay-loader-service/loader-handler.service';

@Component({
  selector: 'app-overlay-loader',
  templateUrl: './overlay-loader.component.html',
  styleUrls: ['./overlay-loader.component.scss']
})
export class OverlayLoaderComponent {
  showloader: any = false;
  subscription: any;
  constructor(private loaderHandler: LoaderHandlerService) {
    this.subscription = this.loaderHandler.handler$.subscribe((value) => {
      this.showloader = value;
    });
  }
}
